<div class="auth-container domain-redirect" [ngClass]="{'desktop': isDesktop, 'mobile': !isDesktop}">
  <div class="auth-header">
    <h2 i18n>We've Moved!</h2>
  </div>

  <div class="redirect-body">
    <p class="redirect-message" i18n>
      Our website has moved to a new address. You will be redirected automatically.
    </p>

    <div class="new-domain-badge">lemoncasinohu28.com</div>

    <a [href]="newDomainUrl" class="redirect-cta-btn" (click)="goToNewDomain()">
      <span i18n>Go to New Site</span>
      <span class="arrow-icon">&#8594;</span>
    </a>

    <div class="countdown-text">
      <span i18n>Redirecting in </span><strong>{{ countdown }}</strong><span i18n> seconds...</span>
    </div>
  </div>
</div>
